export const FETCH_USER = 'fetch_user';
export const LOGIN_USER = 'login_user';
export const KEEP_USER = 'keep_user';